import { render, staticRenderFns } from "./ShipStation.vue?vue&type=template&id=4e5f53d2"
import script from "./ShipStation.vue?vue&type=script&lang=js"
export * from "./ShipStation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports